import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ATTEMPTS_SECURITY_SHOW = "permission/showAttemptsSecurity";
const USER_SECURITY_SHOW = "permission/showUserSecurity";

export const showAttemptsSecurity = createAsyncThunk(
  ATTEMPTS_SECURITY_SHOW,
  async (thunkAPI) => {
    try {
      const data_source = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}AttemptsSecurity`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return data_source;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showUserSecurity = createAsyncThunk(
  USER_SECURITY_SHOW,
  async (thunkAPI) => {
    try {
      const data_source = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}UserSecurity`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
          
        }),
        expand: "User,AttemptsSecurity",
      });
      return data_source;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
